<template>
  <hr class="sx-hr" />
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped="true">
.sx-hr {
  height: 1px;
  min-width: 100%;
  width: 100%;

  border: 0 !important;
  background-color: var(--gray-50);
}
</style>
